<template>
  <div class="v3-popup task-rule-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content large">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">{{ langData.taskRuleRules }}</div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="handleClose"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";

import LanguageHook from "@hooks/language";

// 语言相关
const { langData } = LanguageHook();

const v3PopupState = inject("v3PopupState");

const handleClose = () => {
  v3PopupState.taskPopupState = false;
};
</script>

<style scoped lang="less"></style>
